import { add } from 'date-fns';
import {
	QUICK_DATE_FILTER_ALL_TIME,
	QUICK_DATE_FILTER_CUSTOM,
	QUICK_DATE_FILTER_PAST_2_WEEKS,
	QUICK_DATE_FILTER_PAST_3_MONTHS,
	QUICK_DATE_FILTER_PAST_6_MONTHS,
	QUICK_DATE_FILTER_PAST_MONTH,
	QUICK_DATE_FILTER_PAST_WEEK,
} from '../../common/constants';
import type { QUICK_DATE_FILTER, ZoomState } from '../../common/types';

export type SimpleMomentTimeDiff = {
	weeks?: number;
	months?: number;
	days?: number;
	hours?: number;
	minutes?: number;
	seconds?: number;
	years?: number;
};

export const getTimeDiffForQuickDateFilter = (
	quickDateFilter: QUICK_DATE_FILTER,
): SimpleMomentTimeDiff => {
	switch (quickDateFilter) {
		case QUICK_DATE_FILTER_PAST_WEEK:
			return { weeks: -1 };
		case QUICK_DATE_FILTER_PAST_2_WEEKS:
			return { weeks: -2 };
		case QUICK_DATE_FILTER_PAST_MONTH:
			return { months: -1 };
		case QUICK_DATE_FILTER_PAST_3_MONTHS:
			return { months: -3 };
		case QUICK_DATE_FILTER_PAST_6_MONTHS:
			return { months: -6 };
		default:
			return { months: 0, weeks: 0 };
	}
};

export const getQuickDateFilterZoomState = (
	currentZoomState: ZoomState,
	quickDateFilter: QUICK_DATE_FILTER,
	now: Date,
): ZoomState => {
	if (quickDateFilter === QUICK_DATE_FILTER_CUSTOM) {
		return currentZoomState;
	}

	if (quickDateFilter === QUICK_DATE_FILTER_ALL_TIME) {
		return {
			type: 'none',
		};
	}

	const timeDiff = getTimeDiffForQuickDateFilter(quickDateFilter);
	const toDate = now;
	const fromDate = add(toDate, timeDiff);

	return {
		type: 'value',
		startValue: fromDate.getTime(),
		endValue: toDate.getTime(),
	};
};
